import { render, staticRenderFns } from "./excursionParticipationComp.vue?vue&type=template&id=2d08ad0f"
import script from "./excursionParticipationComp.vue?vue&type=script&lang=js"
export * from "./excursionParticipationComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports